import {
  APIComponentAttributes,
  APIReferenceAttributes,
  ArdoqId,
  BatchComponentId,
  BatchReferenceId,
  BatchRequest,
  ProvenanceSource,
} from '@ardoq/api-types';
import { ApiResponse } from './types';
import {
  Method,
  fetchJson,
  getProvenanceHeaders,
  toRequestOptions,
} from './api';

export type BatchResult = {
  components: {
    ids: Record<BatchComponentId, ArdoqId>;
    created?: Record<ArdoqId, APIComponentAttributes>;
    updated?: Record<ArdoqId, APIComponentAttributes>;
  };
  references: {
    ids: Record<BatchReferenceId, ArdoqId>;
    created?: Record<ArdoqId, APIReferenceAttributes>;
    updated?: Record<ArdoqId, APIReferenceAttributes>;
  };
};

const execute = (
  batch: BatchRequest,
  provenanceSource?: ProvenanceSource
): ApiResponse<BatchResult> => {
  const request = new Request(
    `/api/batch/v2`,
    toRequestOptions(Method.POST, batch, {
      extraHeaders: getProvenanceHeaders(provenanceSource),
    })
  );
  return fetchJson<BatchResult>(request);
};
export const batchApi = {
  execute,
};
